import Routes from 'routes/Routes';
import { configureFakeBackend } from 'helpers';
import { SocketProvider } from './contexts/SocketContext';

// For Default import Saas.scss
import 'assets/scss/Saas.scss';
// import 'assets/scss/Creative.scss';
// import 'assets/scss/Modern.scss';

const App = () => {
    configureFakeBackend();
    return (
        <SocketProvider>
            <Routes />
        </SocketProvider>
    );
};

export default App;
